module.exports = __webpack_public_path__ + "static/media/AgentReferral.22c34256.svg";